export function minus(a, b){
    return a-b
}

export function add(a, b){
    return a+b
}


export function podiliti(a, b){
    return a/b
}